import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  ExploreCTA,
  TabbedCallouts,
  FloorplansList,
  AmenitiesList,
  FeaturedAmenities,
  Gallery,
  NeighborhoodMap,
  NeighborhoodCallout,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNowActions,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  ExploreCTA,
  TabbedCallouts,
  FloorplansList,
  AmenitiesList,
  FeaturedAmenities,
  Gallery,
  NeighborhoodMap,
  NeighborhoodCallout,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNowActions,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
};

export default registry;
